import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/operation_record_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  operatable_type_eq: {
    model_name: 'OperationRecord',
    column_type: 'string',
    column_name: 'operatableType',
  },
  operatable_id_eq: {
    model_name: 'OperationRecord',
    column_type: 'string',
    column_name: 'operatableId',
  },
  request_method_eq: {
    model_name: 'OperationRecord',
    column_type: 'string',
    column_name: 'requestMethod',
  },
  request_path_eq: {
    model_name: 'OperationRecord',
    column_type: 'string',
    column_name: 'requestPath',
  },
  ip_address_eq: {
    model_name: 'OperationRecord',
    column_type: 'string',
    column_name: 'ipAddress',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('OperationRecord', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('OperationRecord', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
